import { IAuditLogChange } from '@/Interfaces/AuditLogChange.interface';
import { fetchAuditLogChanges } from '@/store/api/changeLogHistory.api';
import { useEffect, useState } from 'react';

interface UseAuditLogChangesResult {
  changes: IAuditLogChange[];
  loading: boolean;
  error: Error | null;
}

export const useAuditLogChanges = (auditLogId: number | null): UseAuditLogChangesResult => {
  const [changes, setChanges] = useState<IAuditLogChange[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (auditLogId == null) {
      setChanges([]);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchAuditLogChanges(auditLogId)
      .then(response => {
        if (cancelled) return;
        setChanges(response.changes);
      })
      .catch(err => {
        if (cancelled) return;
        setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [auditLogId]);

  return { changes, loading, error };
};
